export { default } from './switchTheme';
